import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'lib/centralStore';
import { isServerSide } from 'utility/constant';
import { selectIsLoading } from 'features/location/selectors';
import { scrollTop } from 'features/location/utils';
import { navigate } from 'features/location/types';

interface NavigateProps {
  src: string;
  href: string;
}
export const doKick = createAsyncThunk<{}, NavigateProps>('doKick', async ({ src, href }, { dispatch, getState }) => {
  if (isServerSide) {
    return Promise.resolve();
  }

  const nextPath = decodeURI(href);

  // replace the router prefetch action
  // fetch(nextPath, {redirect: 'manual', credentials: 'include', cache: 'no-cache'});

  // anticipate the navigate.pending in order to have more time for signalR register/unregister actions
  dispatch({ type: navigate.pending.type, meta: { arg: nextPath } });

  scrollTop('smooth');

  const delay = 999 * (process.env.NODE_ENV === 'production' ? 0.5 : 2);
  await new Promise((resolve) => setTimeout(resolve, delay));

  const st = getState() as RootState;
  const isLoading = selectIsLoading(st);

  if (!isLoading) {
    return Promise.resolve();
  }

  const me = decodeURI(document.location.pathname);

  if (me === nextPath) {
    // if document.location already changed: document.realod
    console.log(`UI-Navigation.realod ("${src}") -> "${nextPath}"`);
    document.location.reload();
  } else {
    // if document.location still initial: document.replace
    console.log(`UI-Navigation.replace ("${src}") -> "${nextPath}"`);
    document.location.replace(nextPath);
  }

  return Promise.resolve();
});
